import { render } from "./team-info-edit.vue?vue&type=template&id=0f35d44c&scoped=true&ts=true"
import script from "./team-info-edit.vue?vue&type=script&lang=ts"
export * from "./team-info-edit.vue?vue&type=script&lang=ts"

import "./team-info-edit.vue?vue&type=style&index=0&id=0f35d44c&lang=scss&scoped=true"
import "./team-info-edit.vue?vue&type=style&index=1&id=0f35d44c&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f35d44c"]])

export default __exports__